import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Navigator } from "src/app/components/menu/navigator";
import { AppstorageTsService } from 'src/app/services/appstorage/appstorage.ts.service';
import { ConfigService } from 'src/app/services/config/config.service';

@Component({
  selector: 'app-popover-pre-geo-info',
  templateUrl: './popover-pre-geo-info.component.html',
  styleUrls: ['./popover-pre-geo-info.component.scss'],
})
export class PopoverPreGeoInfoComponent implements OnInit {
  public jurisdiction;
  public state = "Pennsylvania";

  constructor(
    public navigator: Navigator,
    public popOverCtrl: PopoverController,
    public config: ConfigService,
    public appStorageService: AppstorageTsService,) { }

  async ngOnInit() {
    this.jurisdiction = await this.appStorageService.getJurisdiction();
    if(this.config.clientAppWithNoJurisdiction()) {
      this.state="Pennsylvania";
    } else if(this.jurisdiction.value == 'PA') {
      this.state = "Pennsylvania";
    }
  }

  onContinue() {
    this.popOverCtrl.dismiss(true);
  }

  onCancel() {
    this.popOverCtrl.dismiss(false);
  }

  closePopover() {
    this.popOverCtrl.dismiss(false);
  }
}
